import * as zod from 'zod';

import { DHCommand } from '@sb/integrations/implementations/dh/comon/types/DHCommand';

export const DHAG105145Command = DHCommand.extend({
  kind: zod.literal('DHAG105145Command'),
});

export type DHAG105145Command = zod.infer<typeof DHAG105145Command>;
